import classNames from 'classnames';
import { BackgroundThemeRevision } from 'referral-types';

import './_styles.scss';

export enum FrostedGlassSubThemeIds {
  sunrise = 'frosted-sunrise',
  cosmos = 'frosted-cosmos',
  ocean = 'frosted-ocean',
  sunset = 'frosted-sunset',
  warpedPlastic = 'frosted-warped-plastic',
  fingerbib = 'frosted-fingerbib',
  nineZeroNine = 'frosted-909',
  ruzz = 'frosted-ruzz',
  mealtime = 'frosted-mealtime',
  salvatami = 'frosted-salvatami',
  kiOku = 'frosted-ki-oku',
  daffodil = 'frosted-daffodil',
}

export const FrostedGlassSubThemeOptions = [
  { value: FrostedGlassSubThemeIds.sunrise, label: 'Frosted Sunrise' },
  { value: FrostedGlassSubThemeIds.cosmos, label: 'Frosted Cosmos' },
  { value: FrostedGlassSubThemeIds.ocean, label: 'Frosted Ocean' },
  { value: FrostedGlassSubThemeIds.sunset, label: 'Frosted Sunset' },
  { value: FrostedGlassSubThemeIds.warpedPlastic, label: 'Warped Plastic' },
  { value: FrostedGlassSubThemeIds.fingerbib, label: 'Fingerbib' },
  { value: FrostedGlassSubThemeIds.nineZeroNine, label: '909' },
  { value: FrostedGlassSubThemeIds.ruzz, label: 'Ruzz' },
  { value: FrostedGlassSubThemeIds.mealtime, label: 'Mealtime' },
  { value: FrostedGlassSubThemeIds.salvatami, label: 'Salvatami' },
  { value: FrostedGlassSubThemeIds.kiOku, label: 'Ki Oku' },
  { value: FrostedGlassSubThemeIds.daffodil, label: 'Daffodil' },
];

export const FrostedBackground = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  let backgroundClass: string;

  switch (themeRevision?.subTheme) {
    case FrostedGlassSubThemeIds.sunrise:
      backgroundClass = 'bg-frosted-sunrise';
      break;
    case FrostedGlassSubThemeIds.sunset:
      backgroundClass = 'bg-frosted-sunset';
      break;
    case FrostedGlassSubThemeIds.cosmos:
      backgroundClass = 'bg-frosted-cosmos';
      break;
    case FrostedGlassSubThemeIds.warpedPlastic:
      backgroundClass = 'bg-frosted-warped-plastic';
      break;
    case FrostedGlassSubThemeIds.fingerbib:
      backgroundClass = 'bg-frosted-fingerbib';
      break;
    case FrostedGlassSubThemeIds.nineZeroNine:
      backgroundClass = 'bg-frosted-909';
      break;
    case FrostedGlassSubThemeIds.ruzz:
      backgroundClass = 'bg-frosted-ruzz';
      break;
    case FrostedGlassSubThemeIds.mealtime:
      backgroundClass = 'bg-frosted-mealtime';
      break;
    case FrostedGlassSubThemeIds.salvatami:
      backgroundClass = 'bg-frosted-salvatami';
      break;
    case FrostedGlassSubThemeIds.kiOku:
      backgroundClass = 'bg-frosted-ki-oku';
      break;
    case FrostedGlassSubThemeIds.daffodil:
      backgroundClass = 'bg-frosted-daffodil';
      break;
    case FrostedGlassSubThemeIds.ocean:
    default:
      backgroundClass = 'bg-frosted-ocean';
      break;
  }

  return <div className={classNames(backgroundClass, 'relative -z-10 h-full w-full')} />;
};
